module.exports = __webpack_public_path__ + "static/img/why-5.11ee2f08.jpg";